import { Box, HStack, Image, Text } from "@chakra-ui/react";
import { useRouter } from "next/navigation";

import { MOBILE_PATHS } from "@/app/(mobile)/lib/paths";

export function MobileHeader() {
  const router = useRouter();
  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bg="#006985"
      zIndex={10}
      borderBottom="1px"
      borderColor="gray.200"
      overflowY="hidden"
      height="60px"
    >
      <HStack w="100%" p={4} align="center" py={2} justify="space-between" height="100%">
        <HStack onClick={() => router.push(MOBILE_PATHS.root)} cursor="pointer">
          <Image
            src="/momentum.png"
            height="24px"
            alt="Momentum"
            filter="brightness(0) invert(1)"
          />
          <Text fontSize="xl" fontWeight="bold" ml={0} color="white">
            Pocket Portfolio
          </Text>
        </HStack>
      </HStack>
    </Box>
  );
}
